import React from 'react';
import { Box, Typography } from '@mui/material';
import { brandColors, APP_FONT_FAMILY, brandCss } from '../../theme/appTheme';

interface PageHeaderProps {
  title: string;
  /** One short line under the title — page purpose */
  subtitle?: string;
  icon?: React.ReactNode;
  /** @deprecated No longer shown in UI */
  isCore?: boolean;
  action?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  action,
}) => (
  <Box sx={{ mb: { xs: 1.25, md: 1.5 } }}>
    <Box sx={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      flexWrap: 'wrap', gap: { xs: 1.5, sm: 2 },
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.25, sm: 1.5 }, minWidth: 0, flex: '1 1 auto' }}>
        {icon && (
          <Box sx={{
            width: { xs: 42, sm: 46 }, height: { xs: 42, sm: 46 }, borderRadius: '12px',
            background: brandCss.formHeaderGradient,
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
            boxShadow: '0 6px 16px rgba(98,33,214,0.22)', flexShrink: 0,
          }}>
            {icon}
          </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h4"
            sx={{
              fontFamily: APP_FONT_FAMILY,
              fontSize: { xs: 22, sm: 26 },
              fontWeight: 800,
              lineHeight: 1.15,
              letterSpacing: '-0.02em',
              color: brandColors.textDark,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                mt: 0.4,
                fontFamily: APP_FONT_FAMILY,
                fontSize: 13,
                fontWeight: 500,
                lineHeight: 1.35,
                color: brandColors.textMuted,
                maxWidth: 720,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {action && (
        <Box sx={{
          flex: { xs: '1 1 100%', sm: '0 0 auto' },
          display: 'flex',
          justifyContent: { xs: 'stretch', sm: 'flex-end' },
          '& > *': { width: { xs: '100%', sm: 'auto' } },
        }}>
          {action}
        </Box>
      )}
    </Box>
  </Box>
);
